'use client';

import { useEffect, useState, type JSX } from 'react';

import { AnimatedProjectionText } from 'DesignSystem2/Projection/AnimatedProjectionText';
import { subtractCents } from 'models/market';

interface AnimatedOddsProps {
    odds: number;
    change: number;
    fontSize?: string;
}

const AnimatedOdds = ({ odds, change, fontSize }: AnimatedOddsProps): JSX.Element => {
    const [performedInitialAnimation, setPerformedInitialAnimation] = useState(false);
    const [activeNumber, setActiveNumber] = useState(subtractCents(odds, change));

    useEffect(() => {
        setTimeout(() => {
            setActiveNumber(odds);
            setPerformedInitialAnimation(true);
        }, 1200);
    }, []);

    useEffect(() => {
        if (performedInitialAnimation) {
            setActiveNumber(odds);
        }
    }, [odds]);

    return <AnimatedProjectionText text={activeNumber + '%'} fontSize={fontSize} numberScrollAnimation={true} />;
};

export default AnimatedOdds;
